import {
  FloatParameterDefinition,
  IntegerParameterDefinition,
  ParameterDefinition,
} from '@automata/wfb-api/src/apis/wfbApiSchemas';
import { ZodError } from 'zod';

export enum ParameterType {
  BOOLEAN = 'Boolean',
  DURATION = 'Duration',
  FLOAT = 'Float',
  INTEGER = 'Integer',
  STRING = 'String',
  FILE = 'File',
}

export type OnChangeFn<T = ParameterDefinition> = <K extends keyof T>(
  field: K,
  value: T[K]
) => void;

export type NumberParameterDefinition =
  | IntegerParameterDefinition
  | FloatParameterDefinition;

type FormField = 'name' | 'default' | 'minimum' | 'maximum';
export type Errors = Partial<Record<FormField, ZodError>>;
